import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const Nenkinshurui = props => {
  return <Dropdown.Static kubunKey='nenkinshurui' {...props} />
}
